/* ============================================================
   ENON TOOLS — Custom PDP UI for Dawn
   File: assets/xt-pdp.js   (load with defer)
   Vanilla, no dependencies, safe to run on every page.
   ============================================================ */
(function () {
  'use strict';

  var money = function (cents, format) {
    var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    v = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || 'Rs. {{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, v);
  };

  /* ---------- 1. Gallery: swipe on touch, click thumbs on desktop ---------- */
  function initGallery(root) {
    var viewport = root.querySelector('[data-xt-viewport]');
    if (!viewport) return;
    var slides = viewport.querySelectorAll('[data-xt-slide]');
    var thumbs = root.querySelectorAll('[data-xt-thumb]');
    var dots = root.querySelectorAll('[data-xt-dot]');
    if (slides.length < 2) return;

    function goTo(i) {
      viewport.scrollTo({ left: viewport.clientWidth * i, behavior: 'smooth' });
    }
    function mark(i) {
      thumbs.forEach(function (b, n) { b.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      dots.forEach(function (b, n) { b.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    }
    thumbs.forEach(function (btn, i) { btn.addEventListener('click', function () { goTo(i); mark(i); }); });
    dots.forEach(function (btn, i) { btn.addEventListener('click', function () { goTo(i); mark(i); }); });

    var raf;
    viewport.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(viewport.scrollLeft / Math.max(1, viewport.clientWidth));
        mark(Math.min(i, slides.length - 1));
      });
    }, { passive: true });

    // arrow keys when the gallery has focus
    viewport.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      var i = Math.round(viewport.scrollLeft / Math.max(1, viewport.clientWidth));
      goTo(Math.max(0, Math.min(slides.length - 1, i + (e.key === 'ArrowRight' ? 1 : -1))));
    });
  }

  /* ---------- 2. Quantity stepper ---------- */
  function initQty(root) {
    root.querySelectorAll('[data-xt-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      if (!input) return;
      wrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-xt-step]');
        if (!btn) return;
        e.preventDefault();
        var step = parseInt(btn.getAttribute('data-xt-step'), 10);
        var min = parseInt(input.min || '1', 10);
        var next = (parseInt(input.value, 10) || min) + step;
        input.value = Math.max(min, next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ---------- 3. Variant select -> hidden id + price + availability ---------- */
  function initVariants(root, scope) {
    var select = root.querySelector('[data-xt-variant-select]');
    if (!select) return;
    var idInput = root.querySelector('[data-xt-variant-id]');
    var priceNows = scope.querySelectorAll('[data-xt-price-now]');
    var priceWases = scope.querySelectorAll('[data-xt-price-was]');
    var stock = root.querySelector('[data-xt-stock]');
    var submit = root.querySelector('[data-xt-submit]');
    var sticky = scope.querySelector('[data-xt-sticky-submit]');
    var format = root.getAttribute('data-money-format') || 'Rs. {{amount}}';

    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      if (!opt) return;
      var available = opt.getAttribute('data-available') === 'true';
      var price = parseInt(opt.getAttribute('data-price'), 10) || 0;
      var cmp = parseInt(opt.getAttribute('data-compare'), 10) || 0;
      if (idInput) idInput.value = opt.value;
      priceNows.forEach(function (el) { el.textContent = money(price, format); });
      priceWases.forEach(function (el) {
        if (cmp > price) { el.textContent = money(cmp, format); el.hidden = false; }
        else { el.hidden = true; }
      });
      if (stock) {
        stock.classList.toggle('xt-stock--out', !available);
        var label = stock.querySelector('[data-xt-stock-text]');
        if (label) label.textContent = available ? (stock.getAttribute('data-in') || 'In stock') : (stock.getAttribute('data-out') || 'Sold out');
      }
      [submit, sticky].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !available;
        var t = btn.querySelector('[data-xt-submit-text]');
        if (t) t.textContent = available
          ? (submit && submit.getAttribute('data-add') || 'Add to cart')
          : (submit && submit.getAttribute('data-sold') || 'Sold out');
      });
      // keep the URL in sync so refresh/share preserves the variant
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', opt.value);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    });
  }

  /* ---------- 4. Related products carousel ---------- */
  function initCarousel(root) {
    root.querySelectorAll('[data-xt-carousel]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-xt-track]');
      if (!track) return;
      wrap.querySelectorAll('[data-xt-scroll]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-xt-scroll') === 'next' ? 1 : -1;
          var card = track.firstElementChild;
          var step = card ? card.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
          track.scrollBy({ left: dir * step, behavior: 'smooth' });
        });
      });
    });
  }

  /* ---------- 5. Share button ---------- */
  function initShare(root) {
    root.querySelectorAll('[data-xt-share]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var data = { title: document.title, url: window.location.href };
        if (navigator.share) { navigator.share(data).catch(function () {}); return; }
        if (navigator.clipboard) {
          navigator.clipboard.writeText(data.url).then(function () {
            var label = btn.querySelector('span');
            if (!label) return;
            var old = label.textContent;
            label.textContent = btn.getAttribute('data-copied') || 'Link copied';
            setTimeout(function () { label.textContent = old; }, 1800);
          });
        }
      });
    });
  }

  /* ---------- 6. Reviews: sort + load more (static list) ---------- */
  function initReviews(root) {
    root.querySelectorAll('[data-xt-reviews]').forEach(function (wrap) {
      var list = wrap.querySelector('[data-xt-review-list]');
      var more = wrap.querySelector('[data-xt-review-more]');
      var perPage = parseInt(wrap.getAttribute('data-per-page') || '2', 10);

      function paint() {
        var items = Array.prototype.slice.call(list.children);
        items.forEach(function (el, i) { el.hidden = i >= perPage; });
        if (more) more.hidden = items.length <= perPage;
      }
      if (list) paint();

      if (more) more.addEventListener('click', function () {
        perPage += parseInt(wrap.getAttribute('data-per-page') || '2', 10);
        paint();
      });

      wrap.querySelectorAll('[data-xt-sort]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          wrap.querySelectorAll('[data-xt-sort]').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          if (!list) return;
          var mode = btn.getAttribute('data-xt-sort');
          var items = Array.prototype.slice.call(list.children);
          items.sort(function (a, b) {
            if (mode === 'newest') {
              return (b.getAttribute('data-date') || '').localeCompare(a.getAttribute('data-date') || '');
            }
            return (parseInt(b.getAttribute('data-helpful') || '0', 10)) - (parseInt(a.getAttribute('data-helpful') || '0', 10));
          });
          items.forEach(function (el) { list.appendChild(el); });
          paint();
        });
      });

      wrap.querySelectorAll('[data-xt-helpful]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.dataset.voted) return;
          btn.dataset.voted = '1';
          var n = btn.querySelector('[data-xt-helpful-count]');
          if (n) n.textContent = (parseInt(n.textContent, 10) || 0) + 1;
          btn.style.borderColor = 'var(--xt-red)';
          btn.style.color = 'var(--xt-red)';
        });
      });
    });
  }

  /* ---------- 7. Sticky mobile buy bar ---------- */
  function initStickyBar(scope) {
    var bar = scope.querySelector('[data-xt-stickybar]');
    var anchor = scope.querySelector('[data-xt-submit]');
    if (!bar || !anchor) return;
    bar.hidden = false;
    document.body.classList.add('xt-has-stickybar');

    var show = function (on) { bar.classList.toggle('is-visible', on); };

    if ('IntersectionObserver' in window) {
      // visible only once the real Add to cart button has scrolled past
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          show(!e.isIntersecting && e.boundingClientRect.top < 0);
        });
      }, { rootMargin: '0px 0px -20% 0px', threshold: 0 }).observe(anchor);
    } else {
      var onScroll = function () { show(anchor.getBoundingClientRect().bottom < 0); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  function boot(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-xt-product]').forEach(function (el) {
      var section = el.closest('.xt-section') || root;
      initGallery(el); initQty(el); initVariants(el, section); initShare(el);
      initStickyBar(section);
    });
    initCarousel(root);
    initReviews(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else { boot(); }

  // Re-init after a Shopify theme-editor section reload
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
